import { Row, Col, Container } from "react-bootstrap";

const Freetrial = () => {
  const perks = ["No strings attached", "No credit card required", "All features included"];

  return (
    <Container fluid>
      <Row className="opacity-bg lp-freetrial-bar">
        <Col className="lp-freetrial-content">
          <h3 className="lp-freetrial-heading">30-day free trial</h3>
          <div className="lp-freetrial-perks">
            {perks.map((perk) => (
              <span key={perk} className="lp-freetrial-perk">
                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 14 15" fill="none" style={{ marginRight: "0.5rem", flexShrink: 0 }}>
                  <circle cx="7" cy="7.5" r="7" fill="#45C646" />
                </svg>
                {perk}
              </span>
            ))}
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default Freetrial;
